import { render, staticRenderFns } from "./SmeDigital.vue?vue&type=template&id=724267f2&scoped=true"
import script from "./SmeDigital.vue?vue&type=script&lang=js"
export * from "./SmeDigital.vue?vue&type=script&lang=js"
import style0 from "./SmeDigital.vue?vue&type=style&index=0&id=724267f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724267f2",
  null
  
)

export default component.exports